export default __webpack_public_path__ + "static/media/success-icon.1cd9a40b.svg";